import raciProps from './parts/RaciProperties.js'

import { ListGroup } from '@bpmn-io/properties-panel'
import { isNotSupported } from './util.js'

const LOW_PRIORITY = 500

export default function RaciPropertiesProvider(propertiesPanel, injector) {
  this.getGroups = function (element) {
    return function (groups) {
      if (!isNotSupported(element)) {
        groups.push(createRaciGroup(element, injector))
      }

      return groups
    }
  }

  propertiesPanel.registerProvider(LOW_PRIORITY, this)
}

RaciPropertiesProvider.$inject = ['propertiesPanel', 'injector']

function createRaciGroup(element, injector) {
  const raciGroup = {
    id: 'raci',
    label: 'RACI',
    component: ListGroup,
    ...raciProps({ element, injector }),
  }

  return raciGroup
}
